<template>
  <v-container grid-list-md text-xs-left v-if="driverSingle !== null && pageDataReady.isReady">

    <v-breadcrumbs divider="/" class="ml-1 pb-0">
      <v-breadcrumbs-item
        v-for="breadcrumb in breadcrumbs"
        :key="breadcrumb.name"
        :disabled="typeof breadcrumb.link === 'undefined'"
        :to="typeof breadcrumb.link !== 'undefined' ? breadcrumb.link : ''"
      >
        {{ breadcrumb.name }}
      </v-breadcrumbs-item>
    </v-breadcrumbs>

    <v-layout row>
      <v-flex xs12>
        <!--<h1 class="text-xs-left ma-3">{{driverSingle.driver.user.surname !== null ? driverSingle.driver.user.surname : ''}} {{driverSingle.driver.user.first_name !== null ? driverSingle.driver.user.first_name : ''}} {{driverSingle.driver.user.patronymic !== null ? driverSingle.driver.user.patronymic : ''}}</h1>-->
        <h1 class="text-xs-left ma-3">Данные водителя за день</h1>
      </v-flex>
    </v-layout>

    <v-layout row class="ml-3">
      <v-flex xs12 md12 lg12>

        <v-layout class="elevation-1 white mb-4 pa-3">
          <v-flex xs12>
            <v-avatar
              :tile="false"
              :size="72"
              color="grey lighten-4"
              class="ma-3 float-left"
            >
              <img :src="driverSingle.driver.user.photo.url_resized" alt="avatar">
            </v-avatar>
            <div>
              <p class="title mt-4 mb-2">{{driverSingle.driver.user.surname}} {{driverSingle.driver.user.first_name}}
                {{driverSingle.driver.user.patronymic}}</p>
              <p class="body-1">{{this.dateFormat(driverSingle.driver.time_start)}}</p>
            </div>
          </v-flex>
        </v-layout>

        <p class="title">Карта посещений</p>
        <v-layout class="elevation-1 white mb-4 pa-3">
          <v-flex xs12>
            <div id="leaflet-map" style="width: 100%; height: 700px;"></div>
          </v-flex>
        </v-layout>

        <p class="title">Список точек по маршруту</p>
        <v-layout class="mb-4">
          <v-flex xs12>
            <v-data-table
              :headers="RoutingHeaders"
              :items="RoutingItems"
              class="elevation-1"
              no-data-text="Нет данных"
              hide-default-header="true"
              hide-actions
            >
              <template slot="items" slot-scope="props">
                <td class="text-xs-left"><b>{{ props.item.k}}</b></td>
                <td class="text-xs-left">{{ props.item.v }}</td>
                <td class="text-xs-left">{{ props.item.v2 }}</td>
                <td class="text-xs-left">{{ props.item.v3 }}</td>
              </template>
            </v-data-table>
          </v-flex>
        </v-layout>

        <v-layout class="mb-4">
          <v-flex xs12>
            <v-data-table
              :headers="RoutingPointHeaders"
              :items="RoutingPointItems"
              class="elevation-1 driver-single-table"
              no-data-text="Нет данных"
              hide-actions
            >
              <template slot="headerCell" slot-scope="props">
                <v-tooltip bottom>
                  <span slot="activator">
                    {{ props.header.text }}
                  </span>
                  <span>
                    {{ props.header.text }}
                  </span>
                </v-tooltip>
              </template>
              <template slot="items" slot-scope="props">
                <td><b>План&nbsp;ЛР</b><br><b>Факт&nbsp;МП</b><br><b>Факт&nbsp;GPS</b></td>
                <td v-html="props.item.number"></td>
                <td class="text-xs-left"><b>{{ props.item.point}}</b><br>{{ props.item.address}}</td>
                <td class="text-xs-left">
                  <v-tooltip top>
                    <span slot="activator" v-html="props.item.arrived"></span>
                    <span>Плановое время прибытия по логистике развоза
                      <br>Время отметки о прибытии в Producto Driver (расстояние до точки в этот момент)
                      <br>Время, когда по GPS водитель оказался рядом с точкой ближе 200 метров
                    </span>
                  </v-tooltip>
                </td>
                <td class="text-xs-left" v-html="props.item.departure"></td>
                <td class="text-xs-left" v-html="props.item.unloading"></td>
                <td class="text-xs-left" v-html="props.item.next"></td>
                <td class="text-xs-left" :style="{background: props.item.row_color}" v-html="props.item.status"></td>
              </template>
            </v-data-table>
          </v-flex>
        </v-layout>

        <p class="title">Список заказов</p>
        <v-layout class="mb-4">
          <v-flex xs12>
            <v-data-table
              :headers="OrderHeaders"
              :items="OrderItems"
              class="elevation-1 driver-single-table driver-order-list-table"
              no-data-text="Нет данных"
              hide-actions
            >
              <template slot="headerCell" slot-scope="props">
                <v-tooltip bottom>
                  <span slot="activator">
                    {{ props.header.text }}
                  </span>
                  <span>
                    {{ props.header.text }}
                  </span>
                </v-tooltip>
              </template>
              <template slot="items" slot-scope="props">
                <td class="text-xs-left">{{ props.item.point }}</td>
                <td class="text-xs-left">{{ props.item.sum }} ₽</td>
                <td class="text-xs-left">{{ props.item.weight }} кг</td>
                <td class="text-xs-left">{{ props.item.status }}</td>
              </template>
            </v-data-table>
          </v-flex>
        </v-layout>

        <p class="title">Список возвратов</p>
        <v-layout class="mb-4">
          <v-flex xs12>
            <v-data-table
              :headers="RefundHeaders"
              :items="RefundItems"
              class="elevation-1 driver-single-table"
              no-data-text="Нет данных"
              hide-actions
            >
              <template slot="headerCell" slot-scope="props">
                <v-tooltip bottom>
                  <span slot="activator">
                    {{ props.header.text }}
                  </span>
                  <span>
                    {{ props.header.text }}
                  </span>
                </v-tooltip>
              </template>
              <template slot="items" slot-scope="props">
                <td class="text-xs-left">{{ props.item.point }}</td>
                <td class="text-xs-left">{{ props.item.sum }} ₽</td>
                <td class="text-xs-left">{{ props.item.weight }} кг</td>
                <td class="text-xs-left">{{ props.item.status }}</td>
              </template>
            </v-data-table>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>

  </v-container>
</template>

<style>
  table.v-table tbody td:first-child, table.v-table tbody td:not(:first-child), table.v-table tbody th:first-child, table.v-table tbody th:not(:first-child), table.v-table thead td:first-child, table.v-table thead td:not(:first-child), table.v-table thead th:first-child, table.v-table thead th:not(:first-child) {
    padding: 0 10px !important;
  }
</style>

<script>
  import L from 'leaflet'
  import 'leaflet/dist/leaflet.css'
  import 'leaflet-routing-machine/dist/leaflet-routing-machine.css'
  import 'leaflet-routing-machine'
  import 'lrm-graphhopper'
  import 'leaflet-extra-markers'
  import 'leaflet-extra-markers/dist/css/leaflet.extra-markers.min.css'
  import '@fortawesome/fontawesome-free/css/all.min.css'

  export default {
    data () {
      return {
        breadcrumbs: [
          {name: 'Главная', link: '/'},
          {name: 'Рейтинг водителей', link: '/drivers/rating'},
          {name: 'Данные водителя за день'}
        ],
        pageDataReady: {
          isReady: false,
          driver: false
        },
        RoutingHeaders: [
          {text: 'Параметр', sortable: false, value: 'k'},
          {text: 'План', sortable: false, value: 'v'},
          {text: 'Факт', sortable: false, value: 'v2'},
          {text: 'Отклонение', sortable: false, value: 'v3'}
        ],
        RoutingPointHeaders: [
          {text: '', sortable: false, value: 'titles'},
          {text: '№', sortable: false, value: 'number'},
          {text: 'Торговая точка', sortable: false, value: 'point'},
          {text: 'Приехал', sortable: false, value: 'arrived'},
          {text: 'Уехал', sortable: false, value: 'departure'},
          {text: 'Разгрузка', sortable: false, value: 'unloading'},
          {text: 'До сл ТТ', sortable: false, value: 'next'},
          {text: 'Статус', sortable: false, value: 'status'}
        ],
        OrderHeaders: [
          {text: 'Торговая точка', sortable: false, value: 'point'},
          {text: 'Сумма заказа', sortable: false, value: 'sum'},
          {text: 'Вес заказа', sortable: false, value: 'weight'},
          {text: 'Статус', sortable: false, value: 'status'}
        ],
        RefundHeaders: [
          {text: 'Торговая точка', sortable: false, value: 'point'},
          {text: 'Сумма возврата', sortable: false, value: 'sum'},
          {text: 'Вес возврата', sortable: false, value: 'weight'},
          {text: 'Статус', sortable: false, value: 'status'}
        ],
        PaymentHeaders: [
          {text: 'Торговая точка', sortable: false, value: 'point'},
          {text: 'Дата создания', sortable: false, value: 'createdDatetime'},
          {text: 'Сумма', sortable: false, value: 'sum'}
        ],
        RoutingPointItems: [],
        OrderItems: [],
        RefundItems: [],
        PaymentItems: [],
        RoutingItems: [],
        map: null
      }
    },
    beforeCreate () {
      this.$store.commit('setPageLoading', true)
      this.$store.commit('setPageTitle', 'Данные водителя за день')
      this.$store.dispatch('getDriverSingle', {id: this.$route.params.id, date: this.$route.params.date})
    },
    created () {
      let getParam = ''
      Object.keys(this.$route.query).forEach((item, i) => {
        getParam += i === 0 ? '?' + item + '=' + this.$route.query[item] : '&' + item + '=' + this.$route.query[item]
      })
      this.breadcrumbs[1].link += getParam
    },
    computed: {
      driverSingle () {
        return this.$store.getters.driverSingle
      }
    },
    methods: {
      pageDataStatus () {
        if (!this.pageDataReady.driver) {
          return false
        }

        this.pageDataReady.isReady = true
        this.$store.commit('setPageLoading', false)
      },
      initLeaflet () {
        if (this.map) {
          return
        }

        // Create Leaflet map on map element.
        let map = L.map(document.getElementById('leaflet-map'), {
          preferCanvas: true,
          center: L.latLng(51.533103, 46.034158),
          zoom: 12
        })

        this.map = map

        // Add OSM tile layer to the Leaflet map.
        L.tileLayer('http://{s}.tile.osm.org/{z}/{x}/{y}.png', {
          attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
        }).addTo(map)

        let markers = []
        let lines = []

        let gpsList = this.driverSingle.gps_list
        for (let i = 0; i < gpsList.length; i++) {
          let gps = this.driverSingle.gps_list[i]
          let latLng = L.latLng(gps.coordinate.lat, gps.coordinate.lng)

          let diff = 0
          let prev = null
          if (i > 0) {
            prev = this.driverSingle.gps_list[i - 1]
            let d1 = this.$moment(gps.datetime)
            let d2 = this.$moment(prev.datetime)
            diff = d1.diff(d2, 'minutes')
          }

          if (diff > 3) {
            if (lines.length > 1) {
              L.polyline(lines, {color: 'black', stroke: 1, bubblingMouseEvents: false, interactive: false}).addTo(map)
            }

            lines = []
            lines.push(latLng)

            L.Routing.control({
              router: new L.Routing.GraphHopper('', {
                serviceUrl: 'https://backendv2.producto.store:746/route'
              }),
              show: false,
              fitSelectedRoutes: false,
              waypointMode: 'snap',
              waypoints: [L.latLng(prev.coordinate.lat, prev.coordinate.lng), latLng],
              lineOptions: {
                styles: [{color: 'white', opacity: 0.15, weight: 1}, {color: 'white', opacity: 0, weight: 1}, {color: 'black', opacity: 1, weight: 5}],
                addWaypoints: false
              }
            }).addTo(map)
          } else {
            lines.push(latLng)
          }

          markers.push(L.circleMarker(latLng, {
            color: '#3388ff',
            radius: 7,
            fillOpacity: 1,
            stroke: false,
            interactive: true
          }).bindPopup('<b>' + this.convertTime(gps.datetime) + '</b>').addTo(map))
        }

        if (lines.length > 1) {
          L.polyline(lines, {color: 'black', stroke: 1, bubblingMouseEvents: false, interactive: false}).addTo(map)
        }

        if (gpsList.length > 0) {
          let first = gpsList[0]
          let last = gpsList[gpsList.length - 1]
          let firstLatLng = L.latLng(first.coordinate.lat, first.coordinate.lng)
          let lastLatLng = L.latLng(last.coordinate.lat, last.coordinate.lng)

          L.marker(firstLatLng, {
            icon: L.ExtraMarkers.icon({
              icon: 'fa-truck',
              markerColor: 'green',
              prefix: 'fas'
            })
          }).bindPopup('<b>' + this.convertTime(first.datetime) + '</b>').addTo(map)

          L.marker(lastLatLng, {
            icon: L.ExtraMarkers.icon({
              icon: 'fa-truck',
              markerColor: 'blue',
              prefix: 'fas'
            })
          }).bindPopup('<b>' + this.convertTime(last.datetime) + '</b>').addTo(map)
        }

        let points = []
        let wayPoints = []

        if (this.driverSingle.driver.point_address_start !== null && this.driverSingle.driver.point_lat_start !== null) {
          let startLatLng = L.latLng(this.driverSingle.driver.point_lat_start, this.driverSingle.driver.point_lng_start)
          wayPoints.push(startLatLng)

          points.push(L.marker(startLatLng, {
            title: this.driverSingle.driver.point_address_start,
            icon: L.ExtraMarkers.icon({
              icon: 'fa-number',
              markerColor: 'blue-dark',
              shape: 'circle',
              prefix: 'fa',
              number: '0'
            })
          }).bindPopup('<b>' + this.driverSingle.driver.point_address_start + '</b>').addTo(map))
        }

        for (let i = 0; i < this.driverSingle.routing_point_list.length; i++) {
          let routingPoint = this.driverSingle.routing_point_list[i]
          let point = routingPoint.point
          let latLng = L.latLng(point.coordinate.lat, point.coordinate.lng)

          wayPoints.push(latLng)

          points.push(L.marker(latLng, {
            title: point.title,
            icon: L.ExtraMarkers.icon({
              icon: 'fa-number',
              markerColor: routingPoint.fact_date_departure ? 'green' : (routingPoint.fact_date_arrival ? 'yellow' : 'red'),
              iconColor: 'white',
              shape: 'circle',
              prefix: 'fa',
              number: i + 1
            })
          }).bindPopup('<b>' + point.title + '</b><br>' + point.fact_address).addTo(map))

          if (routingPoint.avg_lat !== null) {
            L.marker(L.latLng(routingPoint.avg_lat, routingPoint.avg_lng), {
              title: point.title,
              icon: L.ExtraMarkers.icon({
                icon: 'fa-number',
                markerColor: 'cyan',
                iconColor: 'white',
                shape: 'circle',
                prefix: 'fas',
                number: i + 1
              })
            }).bindPopup('<b>' + point.title + '</b><br>' + point.fact_address).addTo(map)
          }
        }

        if (points.length > 0) {
          map.fitBounds((new L.FeatureGroup(points)).getBounds())
        }

        L.Routing.control({
          router: new L.Routing.GraphHopper('', {
            serviceUrl: 'https://backendv2.producto.store:746/route'
          }),
          show: false,
          fitSelectedRoutes: false,
          waypointMode: 'snap',
          waypoints: wayPoints,
          lineOptions: {
            styles: [{color: 'white', opacity: 0.15, weight: 1}, {color: 'white', opacity: 0, weight: 1}, {color: 'red', opacity: 0.7, weight: 2}],
            addWaypoints: false
          }
        }).addTo(map)

        if (this.driverSingle.driver.point_address_start !== null && gpsList.length > 0 && this.driverSingle.driver.fact_time_end !== null && this.driverSingle.driver.point_lat_start !== null) {
          let last = gpsList[gpsList.length - 1]
          let lastLatLng = L.latLng(last.coordinate.lat, last.coordinate.lng)
          let endLatLng = L.latLng(this.driverSingle.driver.point_lat_start, this.driverSingle.driver.point_lng_start)

          let revertRouting = L.Routing.control({
            router: new L.Routing.GraphHopper('', {
              serviceUrl: 'https://backendv2.producto.store:746/route'
            }),
            show: false,
            fitSelectedRoutes: false,
            waypoints: [lastLatLng, endLatLng],
            lineOptions: {
              styles: [{color: 'white', opacity: 0.15, weight: 1}, {color: 'white', opacity: 0, weight: 1}, {color: 'blue', opacity: 0.7, weight: 2}],
              addWaypoints: false
            }
          }).addTo(map)

          let driver = this.driverSingle.driver
          let routingItems = this.RoutingItems

          revertRouting.on('routeselected', function (val) {
            let revertDistance = Math.ceil(val.route.summary.totalDistance / 1000)
            let distanceDeviation = driver.gps_distance + revertDistance - driver.distance
            routingItems.splice(1, 1, {
              k: 'Пробег',
              v: driver.distance + ' км',
              v2: driver.gps_distance + ' км по GPS + ' + revertDistance + ' км до склада',
              v3: (distanceDeviation > 0 ? '+' + distanceDeviation : distanceDeviation) + ' км'
            })
          })
        }

        // let items = this.RoutingItems
        //
        // routing.on('routeselected', function (val) {
        //   items.splice(2, 0, {
        //     k: 'Расчетный пробег по GraphHopper',
        //     v: Math.ceil(val.route.summary.totalDistance / 1000) + ' км'
        //   })
        // })
      },
      balloonTemplate (date) {
        return `
            <p><span class="font-weight-bold">Время:</span> ${this.$moment(date).format('HH:mm')}</p>
          `
      },
      mapZoomUpdate () {
        if (this.map !== null && this.map.geoObjects.getBounds() !== null) {
          this.map.setBounds(this.map.geoObjects.getBounds())
          if (this.map.getZoom() > 18) {
            this.map.setZoom(18)
          }
        }
      },
      stayTimeFormate (stayTime) {
        if (stayTime === null || typeof stayTime === 'undefined' || stayTime === 0) {
          return '-'
        } else {
          return Math.floor(stayTime / 60)
        }
      },
      visitedDatatime (isVisited, datetimeVisited) {
        if (isVisited === 1) {
          return datetimeVisited !== null ? this.$moment(datetimeVisited).format('HH:mm') : 'Да'
        } else {
          return 'Нет'
        }
      },
      dateFormat (dt) {
        return this.$moment(dt).format('dddd, LL')
      },
      convertTime (dt) {
        return dt !== null ? this.$moment(dt).format('HH:mm') : '–'
      },
      showDeviation (time, dt1, dt2) {
        return time !== null ? ((dt1 > dt2 ? '+' : '-') + time) : '–'
      },
      diffTime (dt1, dt2) {
        let parts = []
        parts.push(this.convertTime(dt1))
        parts.push(this.convertTime(dt2))
        return parts.join('<br>')
      },
      diff (v1, v2) {
        let parts = []
        parts.push(v1 !== null ? v1 : '–')
        parts.push(v2 !== null ? v2 : '–')
        return parts.join('<br>')
      }
    },
    watch: {
      driverSingle (val) {
        this.pageDataReady.driver = true
        this.pageDataStatus()
        let orderTotal = {sumTotal: 0, weightTotal: 0}
        let refundTotal = {sumTotal: 0, weightTotal: 0}

        let totalPlanDurations = this.driverSingle.routing_point_list.slice(1)
          .reduce((prev, cur) => this.$moment.duration(cur.plan_unloading).add(prev),
            this.$moment.duration(this.driverSingle.routing_point_list[0].plan_unloading))

        let totalFactDurations = this.driverSingle.routing_point_list.slice(1)
          .reduce((prev, cur) => this.$moment.duration(cur.fact_unloading).add(prev),
            this.$moment.duration(this.driverSingle.routing_point_list[0].fact_unloading))

        let totalGeoDurations = this.driverSingle.routing_point_list.slice(1)
          .reduce((prev, cur) => this.$moment.duration(cur.unloading_with_devation).add(prev),
            this.$moment.duration(this.driverSingle.routing_point_list[0].unloading_with_devation))

        let totalPlanNextDurations = this.driverSingle.routing_point_list.slice(1)
          .reduce((prev, cur) => this.$moment.duration(cur.plan_time_to_next).add(prev),
            this.$moment.duration(this.driverSingle.routing_point_list[0].plan_time_to_next))

        let totalFactNextDurations = this.driverSingle.routing_point_list.slice(1)
          .reduce((prev, cur) => this.$moment.duration(cur.fact_time_to_next).add(prev),
            this.$moment.duration(this.driverSingle.routing_point_list[0].fact_time_to_next))

        let totalGpsNextDurations = this.driverSingle.routing_point_list.slice(1)
          .reduce((prev, cur) => this.$moment.duration(cur.gps_time_to_next).add(prev),
            this.$moment.duration(this.driverSingle.routing_point_list[0].gps_time_to_next))

        let totalNearest = 0

        for (let i = 0; i < this.driverSingle.routing_point_list.length; i++) {
          this.RoutingPointItems[i] = {
            number: (i + 1) + '<br>' + (this.driverSingle.routing_point_list[i].fact_number ? this.driverSingle.routing_point_list[i].fact_number : '–') + '<br>' + (this.driverSingle.routing_point_list[i].gps_number ? this.driverSingle.routing_point_list[i].gps_number : '–'),
            point: this.driverSingle.routing_point_list[i].point.title,
            address: this.driverSingle.routing_point_list[i].point.fact_address,
            arrived: this.diffTime(this.driverSingle.routing_point_list[i].plan_date_arrival, this.driverSingle.routing_point_list[i].fact_date_arrival) + '&nbsp;(' + (this.driverSingle.routing_point_list[i].arrival_deviation ? this.driverSingle.routing_point_list[i].arrival_deviation : '–') + '&nbsp;км' + ')' + '<br>' + this.convertTime(this.driverSingle.routing_point_list[i].gps_start_unloading),
            departure: this.diffTime(this.driverSingle.routing_point_list[i].plan_date_departure, this.driverSingle.routing_point_list[i].fact_date_departure) + '&nbsp;(' + (this.driverSingle.routing_point_list[i].departure_deviation ? this.driverSingle.routing_point_list[i].departure_deviation : '–') + '&nbsp;км' + ')' + '<br>' + this.convertTime(this.driverSingle.routing_point_list[i].gps_end_unloading),
            unloading: this.diff(this.driverSingle.routing_point_list[i].plan_unloading, this.driverSingle.routing_point_list[i].fact_unloading) + '<br>' + (this.driverSingle.routing_point_list[i].unloading_with_devation !== null ? this.driverSingle.routing_point_list[i].unloading_with_devation : '–') + '&nbsp;(' + (this.driverSingle.routing_point_list[i].nearest ? this.driverSingle.routing_point_list[i].nearest : '–') + '&nbsp;км' + ')',
            next: this.diff(this.driverSingle.routing_point_list[i].plan_time_to_next, this.driverSingle.routing_point_list[i].fact_time_to_next) + '<br>' + (this.driverSingle.routing_point_list[i].gps_time_to_next !== null ? this.driverSingle.routing_point_list[i].gps_time_to_next : '–'),
            status: this.driverSingle.routing_point_list[i].status + (this.driverSingle.routing_point_list[i].comment ? '<br>' + this.driverSingle.routing_point_list[i].comment : ''),
            comment: this.driverSingle.routing_point_list[i].comment,
            row_color: this.driverSingle.routing_point_list[i].row_color
          }

          totalNearest += this.driverSingle.routing_point_list[i].nearest
        }

        this.RoutingPointItems[this.RoutingPointItems.length] = {
          number: '',
          point: 'Суммарная информация',
          address: '',
          arrived: '',
          departure: '',
          unloading: this.$moment.utc(totalPlanDurations.asMilliseconds()).format('HH:mm:ss') + '<br>' + this.$moment.utc(totalFactDurations.asMilliseconds()).format('HH:mm:ss') + '<br>' + this.$moment.utc(totalGeoDurations.asMilliseconds()).format('HH:mm:ss'),
          next: this.$moment.utc(totalPlanNextDurations.asMilliseconds()).format('HH:mm:ss') + '<br>' + this.$moment.utc(totalFactNextDurations.asMilliseconds()).format('HH:mm:ss') + '<br>' + this.$moment.utc(totalGpsNextDurations.asMilliseconds()).format('HH:mm:ss'),
          status: '',
          comment: this.RoutingPointItems[this.RoutingPointItems.length - 1].comment,
          row_color: '',
          geo_deviation: '',
          nearest: Math.round(totalNearest * 100) / 100
        }

        for (let i = 0; i < this.driverSingle.order_list.length; i++) {
          if (!isNaN(this.driverSingle.order_list[i].sum)) {
            orderTotal.sumTotal += this.driverSingle.order_list[i].sum
          }
          if (!isNaN(this.driverSingle.order_list[i].weight)) {
            orderTotal.weightTotal += this.driverSingle.order_list[i].weight
          }
          this.OrderItems[i] = {
            point: this.driverSingle.order_list[i].point !== null ? this.driverSingle.order_list[i].point.title : '',
            createdDatetime: this.driverSingle.order_list[i].created_datetime != null ? this.$moment(this.driverSingle.order_list[i].created_datetime).format('DD.MM.YYYY HH:mm') : '',
            deliveryDate: this.driverSingle.order_list[i].delivery_date !== null ? this.$moment(this.driverSingle.order_list[i].delivery_date).format('DD.MM.YYYY') : '',
            sum: this.driverSingle.order_list[i].sum,
            weight: this.driverSingle.order_list[i].weight,
            status: this.driverSingle.order_list[i].delivery_title,
            paymentDate: this.driverSingle.order_list[i].payment_date !== null ? this.$moment(this.driverSingle.order_list[i].payment_date).format('DD.MM.YYYY') : ''
          }
        }
        this.OrderItems[this.OrderItems.length] = {
          point: 'Итого',
          createdDatetime: '',
          deliveryDate: '',
          sum: orderTotal.sumTotal.toFixed(2),
          weight: orderTotal.weightTotal.toFixed(2),
          paymentDate: '',
          status: ''
        }

        for (let i = 0; i < this.driverSingle.refund_list.length; i++) {
          if (!isNaN(this.driverSingle.refund_list[i].sum)) {
            refundTotal.sumTotal += this.driverSingle.refund_list[i].sum
          }
          if (!isNaN(this.driverSingle.refund_list[i].weight)) {
            refundTotal.weightTotal += this.driverSingle.refund_list[i].weight
          }
          this.RefundItems[i] = {
            point: this.driverSingle.refund_list[i].point !== null ? this.driverSingle.refund_list[i].point.title : '',
            createdDatetime: this.driverSingle.refund_list[i].created_datetime != null ? this.$moment(this.driverSingle.refund_list[i].created_datetime).format('DD.MM.YYYY HH:mm') : '',
            refundDate: this.driverSingle.refund_list[i].refund_date !== null ? this.$moment(this.driverSingle.refund_list[i].refund_date).format('DD.MM.YYYY') : '',
            sum: this.driverSingle.refund_list[i].sum,
            weight: this.driverSingle.refund_list[i].weight,
            status: this.driverSingle.refund_list[i].refund_title
          }
        }
        this.RefundItems[this.RefundItems.length] = {
          point: 'Итого',
          createdDatetime: '',
          refundDate: '',
          sum: refundTotal.sumTotal.toFixed(2),
          weight: refundTotal.weightTotal.toFixed(2),
          status: ''
        }

        this.driverSingle.gpsPath = this.driverSingle.gps_list.map(item => {
          return [item.coordinate.lat, item.coordinate.lng]
        })

        this.driverSingle.gps_list.forEach((item, i) => {
          if (i === 0) {
            this.driverSingle.gps_list[i].icon = '/static/img/placeholder-icon1.png'
          } else if (i === this.driverSingle.gps_list.length - 1) {
            this.driverSingle.gps_list[i].icon = '/static/img/placeholder-icon3.png'
          } else {
            this.driverSingle.gps_list[i].icon = '/static/img/placeholder-icon2.png'
          }
        })

        this.RoutingItems.push({
          k: 'Точка старта',
          v: this.driverSingle.driver.point_address_start,
          v2: this.driverSingle.driver.point_fact_address_start,
          v3: this.driverSingle.driver.point_deviation_start !== null ? this.driverSingle.driver.point_deviation_start + ' км' : '–'
        })
        let distanceDeviation = this.driverSingle.driver.gps_distance - this.driverSingle.driver.distance
        this.RoutingItems.push({
          k: 'Пробег',
          v: this.driverSingle.driver.distance + ' км',
          v2: this.driverSingle.driver.gps_distance + ' км',
          v3: (distanceDeviation > 0 ? '+' + distanceDeviation : distanceDeviation) + ' км'
        })
        this.RoutingItems.push({
          k: 'Время старта',
          v: this.convertTime(this.driverSingle.driver.time_start),
          v2: this.convertTime(this.driverSingle.driver.fact_time_start),
          v3: this.showDeviation(this.driverSingle.driver.fact_time_deviation, this.driverSingle.driver.fact_time_start, this.driverSingle.driver.time_start)
        })
        this.RoutingItems.push({
          k: 'Время окончания',
          v: this.convertTime(this.driverSingle.driver.time_end),
          v2: this.convertTime(this.driverSingle.driver.fact_time_end),
          v3: this.showDeviation(this.driverSingle.driver.time_deviation, this.driverSingle.driver.fact_time_end, this.driverSingle.driver.time_end)
        })
      }
    },
    updated () {
      this.initLeaflet()
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Drivers/DriverSingle.vue